import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { ScheduleRow } from './ScheduleRow';


export class ScheduleTable extends Component {

    constructor(props) {
        super(props);
        this.week = props.week;
        this.weekId = props.weekId;
        this.scheduleData = props.data;
        this.state = { nflWeek: this.scheduleData, loading: true,standingsRedirect:false, editFailedMessage:"" };
    }

    componentDidMount() {
        this.populateSchedule(this.scheduleData);
    }

    handleSubmit = (event) => {
        const formData = new FormData(event.currentTarget);
        event.preventDefault();

        for (let [key, value] of formData.entries()) {

            this.scheduleData = ScheduleTable.updateArray(this.scheduleData, key, value);
        };

        this.upDateWeek(this.scheduleData, this.week,this.weekId);
    }


    renderScheduleTable(schedule) {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-5">
                        <p className="homeRoad">AWAY</p>
                    </div>
                    <div className="col-sm-1">
                        <p className="homeRoad">HOME</p>
                    </div>
                </div>
                <form onSubmit={this.handleSubmit}>
                    {schedule.map((value, index) => {
                        return <ScheduleRow nflMatchup={value} />;
                    })}
                    <button type="submit" className="btn btn-primary nflSubmitBtn">Submit Week</button>
                </form>
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderScheduleTable(this.scheduleData);
        let redirect = this.state.standingsRedirect ? <Redirect to='/standings' /> : '';
        return (
            <div>
                {this.state.editFailedMessage ? <div className="alert alert-danger">{this.state.editFailedMessage}</div> : null}
                {contents}
                {redirect}
            </div>
        );
    }

    async populateSchedule(data) {
        this.setState({ nflStandings: data, loading: false });
    }

    async upDateWeek(data, week,id) {

        week = parseInt(week);
        let nflWeek = { weekData: data, weekNum: week, weekId: id };

        let session = JSON.parse(localStorage.getItem("2k"));
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Session-Token': session ? session.value : '' },
            body: JSON.stringify({ nflWeek })
        };

        const response = await fetch('NflSchedule', requestOptions);

        if (response.status === 401) {
            this.setState({ editFailedMessage: "Must login to make edits." });
            return;
        }

        this.setState({ standingsRedirect: true });
    }

    static updateArray = (arr = [], team, score) => {
        return arr.filter((item) => {

            if (item.awayId == team) {
            item.awayScore = Number(score);
        }

        if (item.homeId == team) {
            item.homeScore = Number(score);
        }

        return true;
        });
  
    }
}